import { msalInstance } from '../context/AuthContext';
import { graphConfig } from '../config/authConfig';

export interface UserProfile {
  displayName?: string;
  mail?: string;
  userPrincipalName?: string;
  id?: string;
}

/**
 * Fetches user profile photo from Microsoft Graph API
 * @returns Promise<string | null> - Base64 encoded image or null if not found
 */
export const fetchUserPhoto = async (): Promise<string | null> => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      return null;
    }

    // Get access token for Microsoft Graph
    const tokenRequest = {
      scopes: ['User.Read'],
      account: accounts[0],
    };

    const response = await msalInstance.acquireTokenSilent(tokenRequest);
    
    // Fetch the photo from Microsoft Graph API
    const photoResponse = await fetch(graphConfig.graphPhotoEndpoint, {
      headers: {
        'Authorization': `Bearer ${response.accessToken}`,
        'Content-Type': 'image/jpeg',
      },
    });

    if (photoResponse.ok) {
      const blob = await photoResponse.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      });
    }

    return null;
  } catch (error) {
    console.warn('Failed to fetch user photo:', error);
    return null;
  }
};

/**
 * Fetches user profile information from Microsoft Graph API
 * @returns Promise<UserProfile | null>
 */
export const fetchUserProfile = async (): Promise<UserProfile | null> => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      return null;
    }

    // Get access token for Microsoft Graph
    const tokenRequest = {
      scopes: ['User.Read'],
      account: accounts[0],
    };

    const response = await msalInstance.acquireTokenSilent(tokenRequest);
    
    // Fetch the profile from Microsoft Graph API
    const profileResponse = await fetch(graphConfig.graphMeEndpoint, {
      headers: {
        'Authorization': `Bearer ${response.accessToken}`,
      },
    });

    if (profileResponse.ok) {
      const profile = await profileResponse.json();
      return profile;
    }

    return null;
  } catch (error) {
    console.warn('Failed to fetch user profile:', error);
    return null;
  }
};
